
<template>
   <svg  class="eicon" aria-hidden="true" :font-size="size" :color="color"  @click="click">
        <use :xlink:href="'#icon-'+type" ></use>
  </svg>
</template>
<script>
export default {
    name: 'eicon',
    props: {
        type: String,
        size: [Number, String],
        color:String
    },
    methods: {
        click() {
            this.$emit('click','');
        }
    }
};
</script>
<style type="text/css">
.eicon {
   width: 1em; height: 1em;
   vertical-align: -0.15em;
   fill: currentColor;
   overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/icon/eicon.vue